var $accfc8e35508e1a4$exports = {};
var $accfc8e35508e1a4$var$burger = document.querySelector(".burger");
var $accfc8e35508e1a4$var$menu = document.querySelector(".menu");
var $accfc8e35508e1a4$var$burgerTitle = document.querySelector(".burger-menu-title");
// Overlay flouté
var $accfc8e35508e1a4$var$overlay = document.createElement("div");
$accfc8e35508e1a4$var$overlay.classList.add("menu-overlay");
document.body.appendChild($accfc8e35508e1a4$var$overlay);
var $accfc8e35508e1a4$var$toggleMenu = function toggleMenu() {
    $accfc8e35508e1a4$var$menu.classList.toggle("is-active");
    $accfc8e35508e1a4$var$burger.classList.toggle("is-active");
    $accfc8e35508e1a4$var$overlay.classList.toggle("is-active");
    $accfc8e35508e1a4$var$burgerTitle.textContent = $accfc8e35508e1a4$var$burger.classList.contains("is-active") ? "CLOSE" : "MENU";
};
$accfc8e35508e1a4$var$burger.addEventListener("click", $accfc8e35508e1a4$var$toggleMenu);
$accfc8e35508e1a4$var$overlay.addEventListener("click", $accfc8e35508e1a4$var$toggleMenu);


//# sourceMappingURL=index.fd18407b.js.map
